import styled from 'styled-components';

const ExtraFeeField = styled.p`
  font-size: 14px;
`;

const ExtraFeeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  line-height: 0;
`;

export { ExtraFeeField, ExtraFeeContainer };
